<div class="content-container" #contentContainer></div>